<template>
  <div class="home">
    <div class="home-container">
      <!-- 政策咨询区域 -->
      <div class="section">
        <div class="section-header">
          <div class="section-title">
            <span class="title-cn">政策资讯</span>
            <span class="title-en">POLICY INTERPRETATION</span>
          </div>
          <div class="more-btn" @click="togo('news')">
            <span>更多</span>
            <i class="el-icon-arrow-right"></i>
          </div>
        </div>

        <div class="policy-content">
          <!-- 左侧大图 -->
          <div class="policy-image">
            <el-carousel height="418px" :interval="5000" arrow="hover">
              <el-carousel-item v-for="item in newsList" :key="item.id" @click.native="getNewsDetail(item.id)">
                <image-view :value="item.path" cusStyle="width: 666px; height: 387px;" />
              </el-carousel-item>
            </el-carousel>
          </div>

          <!-- 右侧新闻列表 -->
          <ul class="policy-list">
            <li
              class="policy-item"
              v-for="item in newsList"
              :key="item.id"
              @click="getNewsDetail(item.id)"
            >
              <span class="policy-dot"></span>
              <div class="policy-title">{{ item.title }}</div>
              <div class="policy-date">{{ item.createTime | formatDate }}</div>
            </li>
          </ul>
        </div>
      </div>

      <!-- 融资产品区域 -->
      <div class="section" style="margin-bottom: 1px;">
        <div class="section-header">
          <div class="section-title">
            <span class="title-cn">融资产品</span>
            <span class="title-en">FINANCING PRODUCT</span>
          </div>
          <div class="more-btn" @click="togo('products')">
            <span>更多</span>
            <i class="el-icon-arrow-right"></i>
          </div>
        </div>

        <!-- 产品卡片网格 -->
        <div class="product-grid">
          <div
            class="product-card"
            v-for="item in wellSellsList.slice(0, 4)"
            :key="item.id"
            @click="goDetail(item.id)"
          >
            <div class="product-name">{{ item.cpmc }}</div>
            <div class="product-rate">
              <span class="rate-tag">热销</span>
              <span>年利率</span>
            </div>
            <span class="rate-value">{{ item.zdnhlv }}%～{{ item.zgnhlv }}%</span>
            <div class="product-info">
              <div class="info-item">
                <span class="info-label">授信周期</span>
                <span class="info-value">{{ item.dkqxxx }}-{{ item.dkqxsx }}个月</span>
              </div>
              <div class="info-divider"></div>
              <div class="info-item">
                <span class="info-label">授信额度</span>
                <span class="info-value">{{ item.dkedxx }}-{{ item.dkedsx }}万</span>
              </div>
            </div>
            <div class="product-org">{{ item.jrjgmc }}</div>
            <div class="product-apply">已经申请<span class="apply-count">{{ item.cpcs }}</span>笔</div>
          </div>
        </div>

        <!-- 横向产品列表 - 轮播 -->
        <el-carousel
          class="product-horizontal-carousel"
          :interval="5000"
          indicator-position="none"
          arrow="hover"
          direction="vertical"
          height="500px"
        >
          <el-carousel-item v-for="(group, gIdx) in creditSellsGroups" :key="gIdx">
            <div class="product-horizontal">
              <div
                class="horizontal-card"
                v-for="item in group"
                :key="item.id"
              >
                <div class="horizontal-image">
                  <image-view v-if="item.images" :value="item.images" cusStyle="width:104px; height: 104px;" :alt="item.cpmc" />
                </div>
                <div class="horizontal-main">
                  <div class="horizontal-name">{{ item.cpmc }}</div>
                  <div class="horizontal-org">{{ item.jrjgmc }}</div>
                </div>
                <div class="horizontal-info">
                  <div class="info-col">
                    <div class="info-col-value">{{ item.zdnhlv }}%～{{ item.zgnhlv }}%</div>
                    <div class="info-col-label">年利率范围</div>
                  </div>
                  <div class="info-col">
                    <div class="info-col-value">{{ item.dkqxxx }}～{{ item.dkqxsx }}个月</div>
                    <div class="info-col-label">贷款期限</div>
                  </div>
                  <div class="info-col">
                    <div class="info-col-value">{{ item.dkedxx }}～{{ item.dkedsx }}万</div>
                    <div class="info-col-label">贷款额度</div>
                  </div>
                  <div class="info-col">
                    <div class="info-col-value">{{ item.dbfsm}}</div>
                    <div class="info-col-label">担保方式</div>
                  </div>
                  <div class="info-col">
                    <div class="info-col-value">{{ item.cpcs || 0 }}笔</div>
                    <div class="info-col-label">已经申请</div>
                  </div>
                </div>
                <div class="horizontal-action">
                  <button class="detail-btn" @click="goDetail(item.id)">查看详情 &gt;</button>
                </div>
              </div>
            </div>
          </el-carousel-item>
        </el-carousel>
      </div>

      <!-- 融资动态区域 -->
      <div class="section">
        <div class="section-header">
          <div class="section-title">
            <span class="title-cn">融资动态</span>
            <span class="title-en">FINANCING DYNAMICS</span>
          </div>
          <div class="more-btn" @click="togo('needs')">
            <span>更多</span>
            <i class="el-icon-arrow-right"></i>
          </div>
        </div>

        <div class="dynamics-grid">
          <div class="dynamics-row" v-for="(row, rowIdx) in activeList.slice(0, 3)" :key="rowIdx">
            <div
              class="dynamics-card"
              v-for="item in row"
              :key="item.id"
            >
            <img src="@/assets/img/2026/house.png" alt />
             <div>
               <div class="dynamics-company">{{ item.qymc }}</div>
              <div class="dynamics-amount">
                授信金额: <span class="amount-value">{{ item.dked }}</span>万
              </div>
             </div>
            </div>
          </div>
        </div>
      </div>

      <!-- 融资流程区域 -->
      <div class="section">
        <div class="section-header">
          <div class="section-title">
            <span class="title-cn">融资流程</span>
            <span class="title-en">FINANCING PROCESS</span>
          </div>
          <div class="more-btn">
            <span>更多</span>
            <i class="el-icon-arrow-right"></i>
          </div>
        </div>

        <div class="process-content">
          <!-- 流程图占位 -->
          <div class="process-image">
            <!-- 图片占位区域 1501x284 -->
            <div class="image-placeholder-large">
              <img src="@/assets/img/2026/rzlc.png" alt />
            </div>
          </div>
        </div>
      </div>

      <!-- 入驻金融机构数区域 -->
      <!-- <div class="section">
        <div class="section-header">
          <div class="section-title">
            <span class="title-cn">入驻金融机构数</span>
            <span class="title-en">FINANCIAL INSTITUTION</span>
          </div>
          <div class="more-btn" @click="togo('organ')">
            <span>更多</span>
            <i class="el-icon-arrow-right"></i>
          </div>
        </div> -->

        <!-- 机构类型筛选 -->
        <!-- <div class="organ-filter">
          <span
            v-for="(item, index) in organTypeList"
            :key="index"
            :class="['filter-tag', { active: selectOrangType == index }]"
            @click="changeOrganType(index, item)"
          >
            {{ item.dictionaryKey }}
          </span>
        </div> -->

        <!-- 机构 Logo 列表 - 双向滚动 -->
        <!-- <div class="organ-scroll-container">
          <div class="organ-scroll-row scroll-left">
            <div class="scroll-track">
              <div
                class="organ-item"
                v-for="(item, idx) in organList.slice(0, 10)"
                :key="'left-' + idx"
              >
                <div class="organ-placeholder">
                  <image-view :value="item.image" cusStyle="width: 271px; height: 70px;"></image-view>
                </div>
              </div>
              <div
                class="organ-item"
                v-for="(item, idx) in organList.slice(0, 10)"
                :key="'left-copy-' + idx"
              >
                <div class="organ-placeholder">
                  <image-view :value="item.image" cusStyle="width: 271px; height: 70px;"></image-view>
                </div>
              </div>
            </div>
          </div> -->

          <!-- 第二行：向右滚动 -->
          <!-- <div class="organ-scroll-row scroll-right">
            <div class="scroll-track">
              <div
                class="organ-item"
                v-for="(item, idx) in organList.slice(10, 20)"
                :key="'right-' + idx"
              >
                <div class="organ-placeholder">
                  <image-view :value="item.image" cusStyle="width: 271px; height: 70px;"></image-view>
                </div>
              </div>
              <div
                class="organ-item"
                v-for="(item, idx) in organList.slice(10, 20)"
                :key="'right-copy-' + idx"
              >
                <div class="organ-placeholder">
                  <image-view :value="item.image" cusStyle="width: 271px; height: 70px;"></image-view>
                </div>
              </div>
            </div>
          </div>
        </div> -->

        <!-- 分页 -->
        <!-- <div class="pagination">
          <el-pagination
            layout="total, sizes, prev, pager, next, jumper"
            :page-sizes="[20, 50, 100]"
            :current-page.sync="pagination.page"
            :page-size.sync="pagination.size"
            :total="pagination.total"
            @current-change="getOrganArr"
            @size-change="queryOrganData"
          />
        </div> -->
      </div>
    </div>
  </div>
</template>

<script>
/* API 导入 */
import {
  getStatistics,
  getNews,
  getCarousel,
  getWellSells,
  getCreditSells,
  getActivList,
  getDictionaryKeys,
  getOrganList,
} from "@/api";
import imageView from ".././imageView.vue";
import { dataKeyMap } from "@/utils/constant";

export default {
  name: "home",
  components: { imageView },
  data() {
    return {
      imgList: [],
      imgList2: [],
      imgList3: [],
      newsList: [],
      financImg1: require("../../assets/img/home/sellwell.png"),
      financImg2: require("../../assets/img/home/creditProduct.png"),
      wellSellsList: [],
      creditSellsList: [],
      activeList: [],
      dictionary: {
        financialInstitution: dataKeyMap.financialInstitution,
      },
      organTypeList: [],
      selectOrangType: null,
      selectCode: "",
      organList: [],
      pagination: {
        page: 1,
        size: 20,
        total: 0,
      },
      statistics: {
        jrjg: 0,
        jrcp: 0,
        rzqy: 0,
        ljfdje: 0,
        fbxqje: 0,
        ljfdbs: 0,
      },
    };
  },
  computed: {
    /** 将信贷产品列表按3个一组分组 */
    creditSellsGroups() {
      const groups = [];
      for (let i = 0; i < this.creditSellsList.length; i += 3) {
        groups.push(this.creditSellsList.slice(i, i + 3));
      }
      return groups;
    }
  },
  async mounted() {
    this.getOrganTypeList();
    window.addEventListener("scroll", this.handleScroll);
  },
  created() {
    this.getStatisticsData();
    this.getCarouselList(2);
    this.getPolicyList();
    this.getWellSellsList();
    this.getCreditSellsList();
    this.getActivArr();
    this.getCarouselList(3);
    this.getOrganArr();
  },
  methods: {
    /** 获取统计数据 */
    getStatisticsData() {
      getStatistics().then((res) => {
        this.statistics = Object.assign({}, this.statistics, res.data);
      });
    },

    /** 获取政策新闻列表 */
    async getPolicyList() {
      const res = await getNews({
        current: 1,
        size: 7,
        type: 2,
      });
      if (res && res.data) {
        this.newsList = res.data.records;
      }
    },

    /** 跳转到新闻详情页 */
    getNewsDetail(id) {
      if (id) {
        this.$router.push("/News/NewsDetail/" + id);
      }
    },

    /** 获取轮播图列表 */
    async getCarouselList(type) {
      const res = await getCarousel({ type });
      if (res && res.data) {
        if (type == 2) {
          this.imgList2 = res.data;
        } else {
          this.imgList3 = res.data;
        }
      }
    },

    /** 获取畅销产品列表 */
    async getWellSellsList() {
      const res = await getWellSells();
      if (res && res.data && res.data.length) {
        this.wellSellsList = res.data;
      }
    },

    /** 跳转到指定页面 */
    togo(path) {
      this.$router.push({ name: path });
    },

    /** 获取融资动态列表 */
    async getActivArr() {
      const res = await getActivList({
        size: 99,
        current: 1,
      });
      if (res && res.data && res.data.records.length) {
        let newArr = [];
        for (let i = 0; i < res.data.records.length; ) {
          newArr.push(res.data.records.slice(i, (i += 3)));
        }
        this.activeList = newArr;
      }
    },

    /** 获取信贷产品列表 */
    async getCreditSellsList() {
      const res = await getCreditSells();
      if (res && res.data && res.data.length) {
        this.creditSellsList = res.data;
      }
    },

    /** 滚动事件处理 */
    handleScroll() {
      var scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop;
      if (scrollTop >= 100) {
        // 滚动逻辑
      }
    },

    /** 获取金融机构类型列表 */
    getOrganTypeList() {
      const key = this.dictionary.financialInstitution;
      if (key) {
        getDictionaryKeys([key]).then((res) => {
          this.organTypeList = res.data[key].children;
        });
      }
    },

    /** 选择金融机构类型 */
    changeOrganType(idx, item) {
      this.selectOrangType = idx;
      this.selectCode = item.code;
      this.getOrganArr();
    },

    /** 获取机构列表 */
    async getOrganArr() {
      const res = await getOrganList({
        current: this.pagination.page,
        size: this.pagination.size,
      });
      if (res && res.data) {
        this.organList = res.data.records;
        this.pagination.total = res.data.total;
      }
    },

    /** 重置分页并查询 */
    queryOrganData() {
      this.pagination.page = 1;
      this.getOrganArr();
    },

    /** 跳转到产品详情页 */
    goDetail(id) {
      this.$router.push("/products/ProductsDetail/" + id);
    },
  },
};
</script>

<style lang="scss"  scoped>
.home {
  min-width: 1200px;
  // background: linear-gradient(180deg, #f0f6ff 0%, #e6f1ff 50%, #e3ecff 100%);
}

.home-container {
  width: 1500px;
  margin: 0 auto;
  padding: 21px 0 40px 0;
}

/* 通用区块样式 */
.section {
  margin-bottom: 21px;
}

.section-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 21px;
}

.section-title {
  display: flex;
  align-items: center;
  gap: 8px;
}

.title-cn {
  font-family: "PingFang SC", sans-serif;
  font-size: 24px;
  line-height: 28px;
  color: #000000;
}

.title-en {
  font-family: "PingFang SC", sans-serif;
  font-weight: 600;
  font-size: 24px;
  line-height: 16px;
  letter-spacing: 0.025em;
  color: rgba(0, 0, 0, 0.25);
}

.more-btn {
  display: flex;
  align-items: center;
  gap: 2px;
  cursor: pointer;
  transition: opacity 0.3s;
}

.more-btn:hover {
  opacity: 0.7;
}

.more-btn span {
  font-family: "Noto Sans SC", sans-serif;
  font-weight: 500;
  font-size: 16px;
  line-height: 16px;
  color: #1366ec;
}

.more-btn i {
  font-size: 14px;
  color: #1366ec;
}

/* 政策咨询区域 */
.policy-content {
  display: flex;
  // gap: 20px;
}

.policy-image {
  width: 666px;
  height: 387px;
  border-radius: 16px;
  overflow: hidden;
  flex-shrink: 0;
  margin-right: 40px;
}

.policy-image ::v-deep .el-carousel__item {
  cursor: pointer;
}

.image-placeholder {
  width: 100%;
  height: 100%;
  background-color: #e8eef5;
  /* 实际使用时替换为真实图片 */
  /* background-image: url('~@/assets/images/policy-image.jpg'); */
  /* background-size: cover; */
  /* background-position: center; */
}

.policy-list {
  width: calc(100% - 666px);
  display: flex;
  flex-direction: column;
  gap: 21px;
  background-color: #fff;
  padding: 27px 21px;
  border-radius: 16px;
}

.policy-item {
  display: flex;
  align-items: center;
  cursor: pointer;
  transition: opacity 0.3s;
}

.policy-item:hover {
  opacity: 0.7;
}

.policy-dot {
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background: #d9d9d9;
  flex-shrink: 0;
  margin-right: 10px;
}

.policy-title {
  font-family: "Noto Sans SC", sans-serif;
  font-size: 18px;
  line-height: 28px;
  color: #000000;
  flex: 1;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.policy-date {
  font-family: "Noto Sans SC", sans-serif;
  font-weight: 400;
  font-size: 18px;
  line-height: 28px;
  color: #999999;
  flex-shrink: 0;
  margin-left: 46px;
}

/* 融资产品区域 */
.product-grid {
  display: flex;
  gap: 40px;
  margin-bottom: 20px;
}

.product-grid .product-card {
  flex: 1;
  min-width: 0;
}

.product-card {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 17px;
  width: 100%;
  height: 364px;
  background: linear-gradient(180deg, rgba(213, 232, 255, 1) 0%, rgba(255, 255, 255, 1) 100%);
  border-radius: 16px;
  box-shadow: 0px 5px 5px 0px rgba(54, 97, 167, 0.05);
  cursor: pointer;
  transition: transform 0.3s, box-shadow 0.3s;
}

.product-card:hover {
  transform: translateY(-8px);
  box-shadow: 0px 8px 16px 0px rgba(54, 97, 167, 0.1);
}

.product-name {
  font-family: "PingFang SC", sans-serif;
  font-weight: 600;
  font-size: 24px;
  line-height: 28px;
  text-align: center;
  color: #000000;
}

.product-rate {
  display: flex;
  align-items: center;
  gap: 17px;
  font-size: 14px;
}

.rate-tag {
  padding: 2px 19px;
  background: #ffcfcf;
  border-radius: 7px;
  font-family: "PingFang SC", sans-serif;
  font-weight: bold;
  font-size: 14px;
  line-height: 28px;
  text-align: center;
  color: #FF0E0E;
}

.rate-value {
  font-family: "PingFang SC", sans-serif;
  font-weight: 600;
  font-size: 28px;
  line-height: 28px;
  color: #1366ec;
}

.product-info {
  display: flex;
  align-items: center;
  gap: 46px;
}

.info-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 9px;
}

.info-label {
  font-family: "PingFang SC", sans-serif;
  font-weight: 400;
  font-size: 14px;
  line-height: 28px;
  text-align: center;
  color: #8DA1C2;
}

.info-value {
  font-family: "PingFang SC", sans-serif;
  font-weight: 600;
  font-size: 16px;
  line-height: 28px;
  text-align: center;
  color: #000000;
}

.info-divider {
  width: 1px;
  height: 64px;
  background: #d9d9d9;
}

.product-org {
  font-family: "PingFang SC", sans-serif;
  font-weight: 400;
  font-size: 14px;
  line-height: 28px;
  text-align: center;
  color: #000000;
}

.product-apply {
  font-family: "PingFang SC", sans-serif;
  font-size: 14px;
  line-height: 28px;
  text-align: center;
  color: #000000;
}

.apply-count {
  color: #1366ec;
}

// .product-horizontal-carousel {
//   margin-top: 1px;
// }

.product-horizontal {
  display: flex;
  flex-direction: column;
  gap: 20px;
  height: 100%;
}
.horizontal-card {
  display: flex;
  align-items: center;
  padding: 20px 30px;
  background: #ffffff;
  border-radius: 16px;
  box-shadow: 0px 5px 5px 0px rgba(54, 97, 167, 0.05);
  transition: transform 0.3s, box-shadow 0.3s;
}

.horizontal-card:hover {
  transform: translateY(-8px);
  box-shadow: 0px 8px 16px 0px rgba(54, 97, 167, 0.1);
}

.horizontal-image {
  width: 104px;
  // height: 80px;
  flex-shrink: 0;
  border-radius: 8px;
  overflow: hidden;
  margin-right: 24px;
}

.horizontal-image img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.horizontal-main {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-right: 40px;
  flex-shrink: 0;
  min-width: 160px;
}

.horizontal-name {
  font-family: "PingFang SC", sans-serif;
  font-weight: 600;
  font-size: 20px;
  color: #000000;
}

.horizontal-org {
  font-family: "PingFang SC", sans-serif;
  font-weight: 400;
  font-size: 14px;
  color: #333333;
  margin-top: 24px;
}

.horizontal-info {
  display: flex;
  justify-content: space-between;
  align-items: center;
  // gap: 40px;
  flex: 1;
}

.info-col {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 4px;
  min-width: 80px;
}

.info-col-value {
  font-family: "PingFang SC", sans-serif;
  font-weight: 600;
  font-size: 16px;
  color: #1366ec;
}

.info-col-label {
  font-family: "PingFang SC", sans-serif;
  font-weight: 400;
  font-size: 14px;
  // color: #666666;
  margin-top: 24px;
}

.horizontal-action {
    width: 140px;
  height: 44px;
  flex-shrink: 0;
  margin-left: 20px;
  position: relative;
}

.detail-btn {
  font-size: 14px;
    content: "";
  position: absolute;
  width: 140px;
  height: 44px;
  border-radius: 46px;
  background: #0077ff;
  border: none;
  color: white;
  background-image: radial-gradient(
      circle at 50% 0%,
      rgba(0, 139, 255, 1) 0%,
      rgba(0, 139, 255, 0) 100%
    ),
    radial-gradient(
      circle at 50% 100%,
      rgba(113, 87, 254, 1) 0%,
      rgba(113, 87, 254, 0) 100%
    );
  box-shadow: 0px 5px 5px 0px rgba(19, 102, 236, 0.13),
    inset 0px 0px 7.9px 0px rgba(255, 255, 255, 1);
  z-index: 0;
}

.detail-btn:hover {
  opacity: 0.85;
}

/* 融资动态区域 */
.dynamics-grid {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.dynamics-row {
  display: flex;
  gap: 20px;
}

.dynamics-card {
  flex: 1;
  display: flex;
  box-shadow: 0px 5px 5px 0px rgba(54, 97, 167, 0.05);
  // justify-content: center;
  align-items: center;
  gap: 9px;
  height: 103px;
  background: #ffffff;
  border-radius: 16px;
  cursor: pointer;
  transition: transform 0.3s, box-shadow 0.3s;
  img{
    width: 100px;
    height: 100px;
    margin: 0 20px;
  }
}

.dynamics-card:hover {
  transform: translateY(-8px);
  box-shadow: 0px 8px 16px 0px rgba(54, 97, 167, 0.1);
}

.dynamics-company {
  font-family: "PingFang SC", sans-serif;
  font-weight: 400;
  font-size: 16px;
  line-height: 28px;
  // text-align: center;
  color: #000000;
}

.dynamics-amount {
  font-family: "PingFang SC", sans-serif;
  font-weight: 400;
  font-size: 14px;
  line-height: 28px;
  // text-align: center;
  color: #000000;
}

.amount-value {
  color: #ff6b00;
  font-size: 22px;
  font-weight: 600;
}

/* 融资流程区域 */
.process-content {
}

.process-image {
  width: 100%;
  height: 290px;
  border-radius: 16px;
  overflow: hidden;
}

.image-placeholder-large {
  width: 100%;
  height: 100%;
  img{
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
  /* 实际使用时替换为真实图片 */
  /* background-image: url('~@/assets/images/process-flow.png'); */
  /* background-size: cover; */
  /* background-position: center; */
}

.process-steps {
  position: relative;
  padding: 31px 99px;
}

.step-line {
  position: absolute;
  top: 50%;
  left: 99px;
  right: 99px;
  height: 4px;
  background: rgba(19, 102, 236, 0.21);
  transform: translateY(-50%);
}

.steps-container {
  display: flex;
  justify-content: space-between;
  position: relative;
  z-index: 1;
}

.step-item {
  display: flex;
  align-items: center;
  gap: 10px;
}

.step-icon {
  width: 24px;
  height: 24px;
  border-radius: 50%;
  background: #1366ec;
}

.step-name {
  font-family: "PingFang SC", sans-serif;
  font-weight: 500;
  font-size: 16px;
  color: #1366ec;
}

/* 入驻金融机构数区域 */
.organ-filter {
  display: flex;
  gap: 36px;
  margin-bottom: 24px;
}

.filter-tag {
  padding: 16px 34px;
  background: transparent;
  border-radius: 8px;
  font-family: "PingFang SC", sans-serif;
  font-weight: 500;
  font-size: 16px;
  color: #666666;
  cursor: pointer;
  transition: all 0.3s;
}

.filter-tag:hover {
  background: #f0f4f8;
}

.filter-tag.active {
  background: #1366ec;
  color: #ffffff;
}

.organ-scroll-container {
  margin-bottom: 24px;
  overflow: hidden;
}

.organ-scroll-row {
  width: 100%;
  overflow: hidden;
  margin-bottom: 20px;
}

.organ-scroll-row:last-child {
  margin-bottom: 0;
}

.scroll-track {
  display: flex;
  gap: 36px;
  width: fit-content;
}

/* 向左滚动 */
.scroll-left .scroll-track {
  animation: scrollLeft 80s linear infinite;
}

/* 向右滚动 */
.scroll-right .scroll-track {
  animation: scrollRight 80s linear infinite;
}

/* 鼠标悬停时暂停动画 */
.organ-scroll-row:hover .scroll-track {
  animation-play-state: paused;
}

/* 向左滚动动画 */
@keyframes scrollLeft {
  0% {
    transform: translateX(0);
  }
  100% {
    transform: translateX(-50%);
  }
}

/* 向右滚动动画 */
@keyframes scrollRight {
  0% {
    transform: translateX(-50%);
  }
  100% {
    transform: translateX(0);
  }
}

.organ-item {
  flex-shrink: 0;
  width: 271px;
  height: 70px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.organ-placeholder {
  width: 271px;
  height: 70px;
}

.pagination {
  display: flex;
  justify-content: flex-end;
  padding: 10px 0;
  border-top: 1px solid #eeeeee;
}
</style>
